import { DateTime } from '@ksyos/date-time';
import { ProcessActivityStatus } from '../../../../../common/enums/ProcessActivityStatus';
import { ServiceCode } from '../../../../../common/enums/ServiceCode';
import { useQuestionnairesProgress } from '../../../../utils/hooks/useQuestionnairesProgress';
import { QuestionnaireCard } from '../../../elements/organisms/questionnaireCard/QuestionnaireCard';
import { getQuestionnaireCardTitle } from '../utils';

type CompleteQuestionnaireListProps = {
    hasBoxShadow?: boolean;
};
export function CompleteQuestionnaireList(props: CompleteQuestionnaireListProps) {
    const { hasBoxShadow } = props;
    const { completedQuestionnaires, questionnaireProcessActivities } = useQuestionnairesProgress(ServiceCode.OSAS);

    const completeQuestionnaireProcessActivities = questionnaireProcessActivities.filter(
        (item) => item.status === ProcessActivityStatus.complete
    );

    return completeQuestionnaireProcessActivities.map((processActivity) => {
        if (
            processActivity.customControlData &&
            'processQuestionnaireResponseId' in processActivity.customControlData
        ) {
            const questionnaireResponse = completedQuestionnaires.find(
                (item) =>
                    processActivity.customControlData &&
                    item.questionnaireResponseId === processActivity.customControlData.processQuestionnaireResponseId
            );

            if (questionnaireResponse) {
                return (
                    <QuestionnaireCard
                        answers={questionnaireResponse.answerCount}
                        body={
                            questionnaireResponse.updated_at
                                ? `${DateTime.from(questionnaireResponse.updated_at).format('DD-MM-YYYY')}`
                                : ''
                        }
                        boxShadow={hasBoxShadow === false ? 'none' : 'base'}
                        className={`automation-${questionnaireResponse.label?.toUpperCase()}`}
                        isSent
                        key={questionnaireResponse.label}
                        questions={questionnaireResponse.questionCount}
                        title={getQuestionnaireCardTitle(questionnaireResponse.label ?? '')}
                        to={'#'}
                    />
                );
            }
        } else {
            return (
                <QuestionnaireCard
                    body={`${DateTime.from(processActivity.updated_at).format('DD-MM-YYYY')}`}
                    boxShadow={hasBoxShadow === false ? 'none' : 'base'}
                    isSent
                    key={'Lifestyle vragenlijst'}
                    title={'Een paar extra vragen'}
                    to={'#'}
                />
            );
        }
    });
}
